import React from 'react';
import PropTypes from 'prop-types';

import { Block as LabelBlock } from '../Label';
import { MaskedNumericInput, VisuallyHidden } from '../Boneyard';
import getFormPartAutomationHook from './getFormPartAutomationHook';
import FieldHandler from './FieldHandler';

const propTypes = {
  ariaLabelOnly: PropTypes.bool,
  name: PropTypes.string.isRequired,
  isRequired: PropTypes.bool,
  label: PropTypes.string.isRequired,
  namespace: PropTypes.string,
  automationHook: PropTypes.string.isRequired,
  resetOnUnmount: PropTypes.bool,
  children: PropTypes.node,
  forceErrorStyles: PropTypes.bool,
  fieldLevelValidation: PropTypes.func,
  placeholder: PropTypes.string,
  withErrorMessage: PropTypes.bool,
  // ... plus other Boneyard Input fields
};

export const MaskedNumericInputField = ({
  ariaLabelOnly,
  children,
  namespace,
  label,
  isRequired,
  name,
  automationHook,
  forceErrorStyles,
  fieldLevelValidation,
  resetOnUnmount = false,
  placeholder,
  withErrorMessage,
  ...props
}) => {
  const fieldAutomationHook = getFormPartAutomationHook(
    automationHook,
    name,
    namespace
  );

  return (
    <>
      {label && !ariaLabelOnly ? (
        <LabelBlock
          htmlFor={name}
          isRequired={isRequired}
          automationHook={fieldAutomationHook}
        >
          {label}
        </LabelBlock>
      ) : (
        <VisuallyHidden>
          <LabelBlock
            htmlFor={name}
            isRequired={isRequired}
            automationHook={fieldAutomationHook}
          >
            {label}
          </LabelBlock>
        </VisuallyHidden>
      )}
      <FieldHandler
        name={name}
        resetOnUnmount={resetOnUnmount}
        forceErrorStyles={forceErrorStyles}
        fieldLevelValidation={fieldLevelValidation}
        withErrorMessage={withErrorMessage}
      >
        <MaskedNumericInput
          {...props}
          name={name}
          id={name}
          withBorder={true}
          automationHook={fieldAutomationHook}
          placeholder={placeholder}
        >
          {React.Children.map(children, child =>
            React.cloneElement(child, { automationHook: fieldAutomationHook })
          )}
        </MaskedNumericInput>
      </FieldHandler>
    </>
  );
};
MaskedNumericInputField.propTypes = propTypes;
MaskedNumericInputField.displayName = 'MaskedNumericInputField';

export default React.memo(MaskedNumericInputField);
